'use strict';

function CreditScoreColours() {
  this.id = null;
  this.node = null;
  this.extends = [];

  this.colorStopsByScores = [[365, '#fc1e2d'], // POOR (300-559)
  [429, '#fc3526'], // POOR (300-559)
  [495, '#fc5123'], // POOR (300-559)

  [593, '#fc943a'], // FAIR (560-659)
  [626, '#fdc069'], // FAIR (560-659)

  [681, '#d7e99b'], // GOOD (660-724)
  [703, '#a9efaa'], // GOOD (660-724)

  [742, '#71f6c4'], // VERY GOOD (725-759)

  [790, '#5deed7'], // EXCELLENT (760-849)
  [819, '#56e4dd'], // EXCELLENT (760-849)

  [866, '#4ad4e8'], // ROCKSTAR (850-900)
  [884, '#43c9ef'] // ROCKSTAR (850-900)
  ];

  this.calculateScoreColor = function (score) {
    var colorStops = this.colorStopsByScores;
    var s = score;
    var distance = Math.abs(colorStops[0][0] - s);
    var idxOfClosest = 0;

    for (var i = 0; i < colorStops.length; i++) {
      var closest = Math.abs(colorStops[i][0] - s);
      if (closest < distance) {
        idxOfClosest = i;
        distance = closest;
      }
    }
    return colorStops[idxOfClosest][1];
  };

  this.destroy = function () {};
}